var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpaWorklistIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.842 3.2v-.802C8.842 1.518 9.976.8 11.375.8h1.25c1.404 0 2.533.716 2.533 1.598V3.2h2.532c.695 0 1.257.358 1.257.8v.8c0 .446-.563.8-1.257.8H6.31c-.695 0-1.257-.358-1.257-.8V4c0-.446.563-.8 1.257-.8h2.532zM7.58 2.4h-1.26c-1.395 0-2.526.713-2.53 1.6H2.523C1.13 4 0 4.712 0 5.603v16.794C0 23.282 1.125 24 2.523 24h18.954C22.87 24 24 23.288 24 22.397V5.603C24 4.718 22.875 4 21.477 4H20.21c-.003-.884-1.13-1.6-2.53-1.6h-1.259C16.42 1.074 14.716 0 12.62 0h-1.24C9.281 0 7.58 1.07 7.58 2.4zM20.21 4.8h1.263c.689 0 1.263.36 1.263.802v16.796c0 .45-.566.802-1.263.802H2.526c-.688 0-1.263-.36-1.263-.802V5.602c0-.45.566-.802 1.263-.802H3.79c.004.884 1.131 1.6 2.53 1.6h11.362c1.395 0 2.526-.713 2.53-1.6zM12 3.2c.349 0 .632-.18.632-.4 0-.22-.283-.4-.632-.4-.349 0-.632.18-.632.4 0 .22.283.4.632.4zm-1.895 7.2v.8H20.21v-.8H10.105zM3.79 9.6V12h3.79V9.6h-3.79zm1.264.8v.8h1.263v-.8H5.053zm-1.264 3.2V16h3.79v-2.4h-3.79zm1.264.8v.8h1.263v-.8H5.053zm5.052 0v.8H20.21v-.8H10.105zM3.79 17.6V20h3.79v-2.4h-3.79zm1.264.8v.8h1.263v-.8H5.053zm5.052 0v.8H20.21v-.8H10.105z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpaWorklistIconmin);
export default __webpack_public_path__ + "static/media/EPAWorklistIcon.min.ec93cea7a6bee09b70b9dca1786a2ac8.svg";
export { ForwardRef as ReactComponent };